import { useState, useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import api from "../../services/api";
import Spinner from "../../shared/Spinner/Spinner";
import Style from "./InstallmentsTableStyle";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import { FaTrashAlt } from "react-icons/fa";
import PageTitle from "../../components/PageTitle";

export default function InstallmentsTable(props) {

  const [loading, setLoading] = useState(true);
  const [installments, setInstallments] = useStateIfMounted({} as any);
  const [installmentSelected, setInstallmentSelected] = useState({} as any);
  const [showDeleting, setShowDeleting] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();

  useEffect(() => {
    LoadInstallments();
  }, []);

  async function LoadInstallments() {
    setLoading(true);
    try {
      const result = await api.get("/installments");
      if (result.data.success) {
        const installments = result.data.installments;
        setInstallments(installments);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Não foi possivel consultar as parcelas: ", result.data);
      }
    } catch (error) {
      setLoading(false);
      console.error("Erro ao consultar as parcelas: ", error);
    }
  }

  function onOpenDelete(installment) {
    setShowDeleting(true);
    setInstallmentSelected(installment);
  }

  function onCloseDelete() {
    setShowDeleting(false);
    setInstallmentSelected({});
  }

  async function onEdit(id: number) {
    props.history.push(`/Installments/${id}`);
  }

  async function onDelete() {
    try {
      setLoading(true);
      const result = await api.delete(`/installment`, {
        data: { id: installmentSelected.id }
      });
      if (result.data.success) {
        setSuccessMessage("Parcela deletada");
      } else {
        setErrorMessage("Problema ao deletar a parcela: " + result.data)
      }
      await LoadInstallments();
      onCloseDelete()
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Erro ao deletar a parcelas: ", error);
    }
  }
  if (loading) return (<Spinner spinning={loading} />);
  return (
    <Style>
      <PageTitle title="Parcelas" />
      <TwoButtonsModal
        show={showDeleting}
        onHide={onCloseDelete}
        loading={loading}
        title="Deleção de parcela!"
        body={`Você tem certeza que deseja deletar a parcela de ID: ${installmentSelected.id}? Essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={onCloseDelete}
        secondaryDisabled={loading}
        primaryText="Deletar"
        primaryOnClick={onDelete}
        primaryDisabled={loading}
      />
      {errorMessage && <p className="alert">Erro: {errorMessage}</p>}
      {successMessage && <p className="alert alert-info">{successMessage}</p>}
      <section className="table-title">
        <h1>Parcelas</h1>
        <button onClick={() => props.history.push('/Installments/0')}>Nova parcela</button>
      </section>
      <table className="table-striped table-bordered table-hover main-table">
        <thead>
          <tr>
            <th>Id</th>
            <th>Empresa</th>
            <th>Parcelas</th>
            <th>Juros</th>
            <th>Data limite</th>
            <th>Excluir</th>
          </tr>
        </thead>
        <tbody>
          {installments?.length > 0 && installments.map(installments => {
            return (
              <tr key={installments.id}>
                <td onClick={() => onEdit(installments.id)} className="clickable">{installments.id}</td>
                <td onClick={() => onEdit(installments.id)} className="clickable">{installments.company}</td>
                <td onClick={() => onEdit(installments.id)} className="clickable">{installments.installment}</td>
                <td onClick={() => onEdit(installments.id)} className="clickable">{installments.interestRate + "%"}</td>
                <td onClick={() => onEdit(installments.id)} className="clickable">{new Date(installments.maxDate).toLocaleString()}</td>
                <td >
                  <div onClick={() => onOpenDelete(installments)}>
                    <FaTrashAlt />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>
  );
}
